import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const ContactUs = () => {
  // ✅ Handle form submission
  const onSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    formData.append("access_key", "4cd4c113-200d-454c-b9a8-ec5a08c0a153");

    // ✅ dynamically set email subject based on selected service
    const selectedService = formData.get("service");
    formData.set("subject", `New Inquiry for ${selectedService}`);

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      }).then((res) => res.json());

      if (res.success) {
        alert("✅ Thank you! Your message has been sent successfully.");
        event.target.reset();
      } else {
        alert("⚠️ Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("❌ Network error. Please try again later.");
    }
  };

  return (
    <div>
      <Helmet>
        <title>
          Contact Us | Orient Elevators Pvt. Ltd. | Elevator & Lift Inquiries
        </title>

        <meta
          name="keywords"
          content="Orient Elevators, elevator contact, lift inquiries, elevator support, customer service, elevator maintenance contact, commercial elevators, home lifts"
        />

        <meta
          name="description"
          content="Get in touch with Orient Elevators Pvt. Ltd. for inquiries, support, or consultation regarding elevators and lifts. Contact our team for prompt and reliable assistance."
        />
      </Helmet>

      {/* ✅ Page Title Section */}
      <section
        className="page-title centred"
        style={{
          backgroundImage: "url('assets/img/slider/slider-2.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "100px 0",
          color: "#fff",
        }}
      >
        <div className="auto-container text-center">
          <div className="content-box">
            <div className="title">
              <h1>Contact Us</h1>
            </div>
            <ul className="bread-crumb clearfix" style={{ listStyle: "none" }}>
              <li>
                <Link
                  to="/"
                  style={{ color: "#fff", textDecoration: "underline" }}
                >
                  Home
                </Link>
              </li>
              <li> / Contact Us</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ✅ Contact Section */}
      <div className="feature-area ft-bg1 py-120" style={{ padding: "80px 0" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="site-heading text-center mb-5">
                <span
                  className="site-title-tagline"
                  style={{ color: "#ec6502" }}
                >
                  <i className="far fa-lightbulb-on"></i> Contact Form
                </span>
                <h2 className="site-title">
                  Get in <span style={{ color: "#ec6502" }}>Touch</span>
                </h2>
              </div>
            </div>
          </div>

          <div className="row flex-row-reverse align-items-center">
            {/* ✅ Google Map */}
            <div className="col-lg-6 mb-4">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4415.517434061427!2d80.98889608713434!3d26.892057350809786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39995804324c8e93%3A0x1e762e7c6d5860e0!2sSector%2017%2C%20Sector%2014%2C%20Indira%20Nagar%2C%20Lucknow%2C%20Uttar%20Pradesh%20226016%2C%20India!5e1!3m2!1sen!2snl!4v1761384344746!5m2!1sen!2snl"
                width="100%"
                height="450"
                style={{ border: 0, borderRadius: "10px" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            {/* ✅ Contact Form */}
            <div className="col-lg-6">
              <div
                className="contact-form-wrap p-4 shadow"
                style={{
                  background: "#fff",
                  borderRadius: "10px",
                  border: "1px solid #ddd",
                }}
              >
                <form onSubmit={onSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        placeholder="Your Name"
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="Email Address"
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <input
                        type="number"
                        className="form-control"
                        name="number"
                        placeholder="Phone Number"
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <select name="service" className="form-select" required>
                        <option value="">Choose Service</option>
                        <option value="Passenger Elevators">
                          Passenger Elevators
                        </option>
                        <option value="Hospital Elevators">
                          Hospital Elevators
                        </option>
                        <option value="Bungalow Elevators">
                          Bungalow Elevators
                        </option>
                        <option value="Capsule Elevators">
                          Capsule Elevators
                        </option>
                        <option value="Goods Elevators">Goods Elevators</option>
                        <option value="Service Elevators">
                          Service Elevators
                        </option>
                      </select>
                    </div>

                    <div className="col-12 mb-3">
                      <textarea
                        placeholder="Message here..."
                        name="message"
                        className="form-control"
                        rows="4"
                        required
                      ></textarea>
                    </div>

                    <div className="col-12 text-center">
                      <button
                        className="theme-btn btn btn-primary mt-3 px-4 py-2"
                        type="submit"
                      >
                        Submit Now <i className="fas fa-arrow-right ms-2"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;

// import React from "react";
// import { Link } from "react-router-dom";

// const ContctUs = () => {

//   const onSubmit = async (event) => {
//     event.preventDefault();

//     const formData = new FormData(event.target);
//     formData.append("access_key", "4cd4c113-200d-454c-b9a8-ec5a08c0a153");

//     const object = Object.fromEntries(formData);
//     const json = JSON.stringify(object);

//     try {
//       const res = await fetch("https://api.web3forms.com/submit", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: json,
//       }).then((res) => res.json());

//       if (res.success) {
//         alert("Thank you! Your message has been sent successfully.");
//         event.target.reset();
//       } else {
//         alert("Something went wrong. Please try again later.");
//       }
//     } catch (error) {
//       console.error("Error submitting form:", error);
//       alert("Network error. Please try again later.");
//     }
//   };

//   return (
//     <div>
//       {/* Page Title Section */}
//       <section
//         className="page-title centred"
//         style={{
//           backgroundImage: "url('assets/img/slider/slider-2.jpg')",
//         }}
//       >
//         <div className="auto-container">
//           <div className="content-box">
//             <div className="title">
//               <h1>Contact Us</h1>
//             </div>
//             <ul className="bread-crumb clearfix">
//               <li>
//                 <Link to="/">Home</Link>
//               </li>
//               <li>Contact Us</li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* Contact Section */}
//       <div className="feature-area ft-bg1 py-120">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-6 mx-auto">
//               <div className="site-heading text-center">
//                 <span className="site-title-tagline">
//                   <i className="far fa-lightbulb-on"></i> Contact form
//                 </span>
//                 <h2 className="site-title ">
//                   Get in <span>Touch</span>
//                 </h2>
//               </div>
//             </div>
//           </div>

//           <div className="row flex-row-reverse">
//             {/* Google Map */}
//             <div className="col-lg-6 text-lg-end">
//               <iframe
//                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4415.517434061427!2d80.98889608713434!3d26.892057350809786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39995804324c8e93%3A0x1e762e7c6d5860e0!2sSector%2017%2C%20Sector%2014%2C%20Indira%20Nagar%2C%20Lucknow%2C%20Uttar%20Pradesh%20226016%2C%20India!5e1!3m2!1sen!2snl!4v1761384344746!5m2!1sen!2snl"
//                 width="100%"
//                 height="450"
//                 style={{ border: 0 }}
//                 allowFullScreen
//                 loading="lazy"
//                 referrerPolicy="no-referrer-when-downgrade"
//               />
//             </div>

//             {/* Contact Form */}
//             <div className="col-lg-6">
//               <div className="contact-form-wrap p-0">
//                 <form onSubmit={onSubmit}>
//                   <div className="row">
//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <input
//                           type="text"
//                           className="form-control"
//                           name="name"
//                           placeholder="Your Name"
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <input
//                           type="email"
//                           className="form-control"
//                           name="email"
//                           placeholder="Email Address"
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <input
//                           type="number"
//                           className="form-control"
//                           name="number"
//                           placeholder="Phone Number"
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <input
//                           type="text"
//                           className="form-control"
//                           name="subject"
//                           placeholder="subject"
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="form-group col-12">
//                       <textarea
//                         placeholder="Message here.."
//                         name="message"
//                         className="form-control"
//                         rows="4"
//                         required
//                       ></textarea>
//                     </div>
//                   </div>

//                   <div className="form-btn col-12">
//                     <button className="theme-btn mt-4" type="submit">
//                       Submit Now <i className="fas fa-arrow-right ms-2"></i>
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContctUs;

// import React from "react";
// import { Link } from "react-router-dom";
// const ContctUs = () => {
//   return (
//     <div>
//       <section
//         className="page-title centred"
//         style={{
//           backgroundImage: "url('assets/img/slider/slider-2.jpg')",
//         }}
//       >
//         <div className="auto-container">
//           <div className="content-box">
//             <div className="title">
//               <h1>Contct Us</h1>
//             </div>
//             <ul className="bread-crumb clearfix">
//               <li>
//                 <Link to="/">Home</Link>
//               </li>
//               <li>Contct Us</li>
//             </ul>
//           </div>
//         </div>
//       </section>
//       <div className="feature-area ft-bg1 py-120">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-6 mx-auto">
//               <div className="site-heading text-center">
//                 <span class="site-title-tagline">
//                   <i class="far fa-lightbulb-on"></i> Contact form
//                 </span>
//                 <h2 className="site-title ">
//                   Get in <span>Touch</span>
//                 </h2>
//               </div>
//             </div>
//           </div>
//           <div className="row flex-row-reverse">
//             <div className="col-lg-6 text-lg-end">
//               <iframe
//                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4415.517434061427!2d80.98889608713434!3d26.892057350809786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39995804324c8e93%3A0x1e762e7c6d5860e0!2sSector%2017%2C%20Sector%2014%2C%20Indira%20Nagar%2C%20Lucknow%2C%20Uttar%20Pradesh%20226016%2C%20India!5e1!3m2!1sen!2snl!4v1761384344746!5m2!1sen!2snl"
//                 width="100%"
//                 height="450"
//                 style={{ border: 0 }}
//                 allowFullScreen
//                 loading="lazy"
//                 referrerPolicy="no-referrer-when-downgrade"
//               />
//             </div>
//             <div className="col-lg-6">
//               <div className="contact-form-wrap p-0">
//                 <form>
//                   <div className="row">
//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <input
//                           type="text"
//                           className="form-control"
//                           name="name"
//                           id="name"
//                           placeholder="Your Name"
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <input
//                           type="text"
//                           className="form-control"
//                           name="email"
//                           id="email"
//                           placeholder="Email Address"
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <input
//                           type="number"
//                           className="form-control"
//                           name="number"
//                           id="phone"
//                           placeholder="Phone Number"
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <select
//                           name="subject"
//                           id="subject"
//                           className="form-select"
//                         >
//                           <option value="Choose" selected="">
//                             Choose Services
//                           </option>
//                           <option value="Passenger Elevators">
//                             Passenger Elevators
//                           </option>
//                           <option value="Hospital Elevators">
//                             Hospital Elevators
//                           </option>
//                           <option value="Bungalow Elevators">
//                             Bungalow Elevators
//                           </option>
//                           <option value="Capsule Elevators">
//                             Capsule Elevators
//                           </option>
//                           <option value="Goods Elevators">
//                             Goods Elevators
//                           </option>
//                           <option value="Service Elevators">
//                             Service Elevators
//                           </option>
//                         </select>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="form-group col-12">
//                     <textarea
//                       placeholder="Message here.."
//                       id="message"
//                       class="form-control"
//                     ></textarea>
//                   </div>
//                   <div className="form-btn col-12">
//                     <button className="theme-btn mt-4 " type="button">
//                       Submit Now <i className="fas fa-arrow-right ms-2"></i>
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default ContctUs;

// import React from "react";

// function ContctUs() {
//   const onSubmit = async (event) => {
//     event.preventDefault();
//     const formData = new FormData(event.target);

//     formData.append("access_key", "4cd4c113-200d-454c-b9a8-ec5a08c0a153");

//     const object = Object.fromEntries(formData);
//     const json = JSON.stringify(object);

//     const res = await fetch("https://api.web3forms.com/submit", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       body: json,
//     }).then((res) => res.json());

//     if (res.success) {
//       console.log("Success", res);
//     }
//   };

//   return (
//     <form onSubmit={onSubmit}>
//       <input type="text" name="name" />
//       <input type="email" name="email" />
//       <textarea name="message"></textarea>
//       <button type="submit">Submit Form</button>
//     </form>
//   );
// }

// export default ContctUs;
